import {
  Login,
  Register,
  RegisterPromo,
  RedirectPassword,
  UpdatePassword,
  SubUser,
  Dashboard,
  Restore,
  FileRestore,
  ImageRestore,
  // Activities,
  Users,
  Account,
  ProfileDetails,
  PlanOptions,
  UpdateCreditCard,
  BillingInformation
} from "App/common/ReactLazy";
import Activities from "App/Activities";
import Idrive360 from "App/Auth/body/Idrive360";
import Logout360 from "App/Auth/body/Logout360";
import Ibackup from "App/Auth/body/Ibackup";
import LogoutIbackup from "App/Auth/body/LogoutIbackup";
import VersionAddAndUpdate from "App/Auth/VersionAddAndUpdate";
import Pns from "App/Auth/Pns";
import AddComputer from "App/Dashboard/AddComputer";
import DetailedProgress from "App/Dashboard/DetailedProgress";
import BackupSettings from "App/Dashboard/BackupSettings";
import BackupScheduleInterval from "App/Dashboard/BackupSettings/Edit/body/Schedule/Interval";
import BackupScheduleDaily from "App/Dashboard/BackupSettings/Edit/body/Schedule/Daily";
import BackupScheduleCustom from "App/Dashboard/BackupSettings/Edit/body/Schedule/Custom";
import BackupScheduleMonthly from "App/Dashboard/BackupSettings/Edit/body/Schedule/Monthly";
import AppLogs from "App/Dashboard/Logs";
import SettingsSummary from "App/Dashboard/BackupSettings/Summary";
import EditSettings from "App/Dashboard/BackupSettings/Edit";
import EmailNotification from "App/Dashboard/BackupSettings/Edit/body/EmailNotification";
import Encryption from "App/Dashboard/BackupSettings/Edit/body/Encryption";
import Schedule from "App/Dashboard/BackupSettings/Edit/body/Schedule";
import Source from "App/Dashboard/BackupSettings/Edit/body/Source";
import AdvanceSettings from "App/Dashboard/BackupSettings/Edit/body/AdvanceSettings";
import CustomLocationBody from "App/Restore/Tabs/body/File/CustomLocationBody";
import DownloadRestoreISO from "App/Restore/Tabs/Header/DownloadISO";
import addUsersPopup from "App/Users/popups/AddUser.jsx";
import usersFailedListPopup from "App/Users/popups/UsersFailedList.jsx";
import AddVirtualMachine from "App/Virtualization/AddVirtualMachine";
import VMConfiguration from "App/Virtualization/VMConfiguration";
import InitImgRestorePopupBody from "App/Restore/Tabs/body/Image/InitImgRestorePopupBody";
// import ProfileDetails from "App/Account/Details/body/ProfileDetails";
// import PlanOptions from "App/Account/Details/body/PlanOptions";
// import UpdateCreditCard from "App/Account/Details/body/UpdateCreditCard";
// import BillingInformation from "App/Account/Details/body/BillingInformation";
import Invoice from "App/Account/Details/body/Invoice";
import PreviewBilling from "App/Account/Details/body/PreviewBilling";
import ClientSetup from "App/Dashboard/AddComputer/ClientSetup";
// Popup imports
import ChangePassword from "App/Account/Details/body/ProfileDetails/ChangePassword";
import PasswordAuth from "App/Account/Details/body/ProfileDetails/PasswordAuth";
import CancelAccount from "App/Account/Details/body/ProfileDetails/CancelAccount";
import CancelAccountConfirmation from "App/Account/Details/body/ProfileDetails/CancelAccountConfirmation";
import UpgradePlanConfirmation from "App/Account/Details/body/UpgradePlanConfirmation";
import SystemRequirements from "App/Dashboard/SystemRequirements";
// Svg imports
import { ReactComponent as SafeOnlineIcon } from "assets/images/app_svg/safe_online.svg";
import { ReactComponent as SafeOfflineIcon } from "assets/images/app_svg/safe_offline.svg";
import { ReactComponent as ErrorOnlineIcon } from "assets/images/app_svg/error_online.svg";
import { ReactComponent as ErrorOfflineIcon } from "assets/images/app_svg/error_offline.svg";
import { ReactComponent as UserIcon } from "assets/images/app_svg/user.svg";
import { ReactComponent as PlanOptionsIcon } from "assets/images/app_svg/plan_options.svg";
import { ReactComponent as UserRefreshIcon } from "assets/images/app_svg/user_refresh.svg";
import { ReactComponent as SettingsIcon } from "assets/images/app_svg/settings.svg";
import { ReactComponent as DollorIcon } from "assets/images/app_svg/dollor.svg";
import { ReactComponent as FilesListingDrive } from "assets/images/app_svg/files_listing_drive.svg";
import { ReactComponent as FilesListingFolder } from "assets/images/app_svg/files_listing_folder.svg";
import { ReactComponent as FilesListingFiles } from "assets/images/app_svg/files_listing_files.svg";
import { ReactComponent as FilesListingWord } from "assets/images/app_svg/files_listing_word.svg";
import { ReactComponent as FilesListingPdf } from "assets/images/app_svg/files_listing_pdf.svg";
import { ReactComponent as FilesListingZip } from "assets/images/app_svg/files_listing_zip.svg";
import { ReactComponent as FilesListingImages } from "assets/images/app_svg/files_listing_images.svg";
import { ReactComponent as FilesListingMusic } from "assets/images/app_svg/files_listing_music.svg";
import { ReactComponent as FilesListingVideo } from "assets/images/app_svg/files_listing_video.svg";
import { ReactComponent as FilesListingUntitled } from "assets/images/app_svg/files_listing_untitled.svg";
import { ReactComponent as BackupIcon } from "assets/images/app_svg/backup.svg";
import { ReactComponent as RestoreIcon } from "assets/images/app_svg/restore.svg";
import { ReactComponent as LogsIcon } from "assets/images/app_svg/logs.svg";
import { ReactComponent as LogsHoverIcon } from "assets/images/app_svg/logs-hover.svg";
import { ReactComponent as AddComputerIcon } from "assets/images/app_svg/add_computer.svg";
import { ReactComponent as EasyConfigIcon } from "assets/images/app_svg/easy_config.svg";
import { ReactComponent as StartBackupIcon } from "assets/images/app_svg/start_backup.svg";
import { ReactComponent as AddComputerNewIcon } from "assets/images/app_svg/add_computer_new.svg";
import { ReactComponent as OfflineAlertIcon } from "assets/images/app_svg/restore/offline_alert.svg";
import { ReactComponent as SuccessAlertIcon } from "assets/images/app_svg/restore/success_alert.svg";
import { ReactComponent as ListViewIconActive } from "assets/images/app_svg/list_view_active.svg";
import { ReactComponent as ListViewIconInActive } from "assets/images/app_svg/list_view_inactive.svg";
import { ReactComponent as GridViewIconActive } from "assets/images/app_svg/grid_view_active.svg";
import { ReactComponent as GridViewIconInActive } from "assets/images/app_svg/grid_view_inactive.svg";
import { ReactComponent as SimultaneousBackupIcon } from "assets/images/app_svg/simultaneousBackupSlider.svg";
import { ReactComponent as SimultaneousRestoreIcon } from "assets/images/app_svg/simultaneousRestoreSlider.svg";
import BackupPlan from "App/BackupPlan";
import BackupPlanSummary from "./BackupPlan/Table/Body/BackupPlanSettings/BackupPlanSummary";
import BackupPlanSettings from "./BackupPlan/Table/Body/BackupPlanSettings/index";
import AddDevices from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/AddDevices";
import { TOOLTIPS } from "consts";
import EditPlanSettings from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/index";
import BackupPlanEmailNotification from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanEmailNotification/index";
import DeleteBackupPlanPopup from "./BackupPlan/Table/Body/DeleteBackupPlanPopup";
import BackupPlanAdvanceSettings from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanAdvanceSettings/index";
import BackupPlanSchedule from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanSchedule/index";
import BackupPlanScheduleCustom from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanSchedule/BackupPlanScheduleCustom";
import BackupPlanDaily from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanSchedule/BackupPlanDaily";
import BackupPlanInterval from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanSchedule/BackupPlanInterval";
import BackupPlanMonthly from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanSchedule/BackupPlanMonthly";
import BackupPlanConflictPopup from "./BackupPlan/Table/Body/BackupPlanSettings/Edit/BackupPlanConflictPopup";
import BackupPlanPropagate from "./BackupPlan/Table/Body/BackupPlanSettings/BackupPlanPropagate";
import CCUpdateLayout from "App/common/hoc/Layout/Toolbar/CCUpdateLayout";
import RenameGroup from "./Dashboard/Header/AddToGroup/RenameGroup";
import AddToGroup from "./Dashboard/Header/AddToGroup/index";
import DeleteGroup from "./Dashboard/Header/AddToGroup/DeleteGroup";
import CreateNewGroup from "./Dashboard/Header/AddToGroup/CreateNewGroup";
import RemoveFromGroup from "./Dashboard/Header/RemoveFromGroup";
import RemoveMachines from "./Dashboard/Header/RemoveMachines";
import ApplyPendingCharges from "./Account/Details/body/ApplyPendingCharges/index";
import Virtualization from "./Virtualization";
import {
  DeleteVirtualInstance,
  RebootVirtualInstance,
  SwitchPowerVirtualInstance
} from "./Virtualization/Machines/Machine/VmControlPopups";
import VMConsole from "./Virtualization/VMConsole";
import BackupProgress from "./Dashboard/Clients/BackupRestoreBothProgress/BackupProgress";
import RestoreDetailedProgress from "./Dashboard/Clients/BackupRestoreBothProgress/RestoreDetailedProgress";
import originalFileRestorePopup from "./Restore/Tabs/originalFileRestorePopup";

export const RESTORE_LIST = [
  {
    key: "file-restore",
    name: "File Restore",
    tab: "file_restore",
    path: "/mirror/restore/:clientUUID/file-restore",
    enum: "FILE_RESTORE_CLIENT",
    component: FileRestore
  },
  {
    key: "image-restore",
    name: "Image Restore",
    tab: "image_restore",
    path: "/mirror/restore/:clientUUID/image-restore",
    enum: "VOLUME_RESTORE",
    component: ImageRestore
  }
];

// Backup Settings
export const BACKUP_SETTINGS = {
  summary: {
    key: "summary",
    name: "Settings Summary",
    component: SettingsSummary
  },
  edit: {
    key: "edit",
    name: "Edit Settings",
    component: EditSettings
  }
};

// Backup Settings Summary
export const BACKUP_SETTINGS_SUMMARY = [
  // {
  //   key: "computerName",
  //   title: "Computer Name"
  // },
  // {
  //   key: "encryption",
  //   title: "Encryption"
  // },

  {
    key: "source",
    title: "Backup Source"
  },
  {
    key: "schedule",
    title: "Backup Schedule"
  },
  {
    key: "advanceSettings",
    title: "Advanced Settings"
  },
  {
    key: "email",
    title: "Email Notification"
  }
];

// Edit Backup Settings
export const EDIT_BACKUP_SETTINGS = {
  email: {
    key: "email",
    name: "Email Notification",
    class: "email",
    component: EmailNotification
  },
  encryption: {
    key: "encryption",
    name: "Encryption",
    class: "encryption",
    component: Encryption
  },
  schedule: {
    key: "schedule",
    name: "Schedule Backup",
    class: "schedule",
    component: Schedule
  },
  source: {
    key: "source",
    name: "Backup Source",
    class: "source",
    component: Source
  },
  advanceSettings: {
    key: "advanceSettings",
    name: "Advanced Settings",
    class: "advance_settings",
    component: AdvanceSettings
  }
};

// Schedule types
export const SCHEDULE_TYPES = {
  MONTHLY: {
    key: "MONTHLY",
    name: "Monthly",
    component: BackupScheduleMonthly
  },
  CUSTOM: {
    key: "CUSTOM",
    name: "Weekly",
    component: BackupScheduleCustom
  },
  DAILY: {
    key: "DAILY",
    name: "Daily",
    component: BackupScheduleDaily
  },
  INTERVAL: {
    key: "INTERVAL",
    name: "Interval",
    component: BackupScheduleInterval
  }
};

// Sliding Popups
export const SLIDING_POPUPS = {
  addPC: [
    {
      key: "addComputer",
      title: "Add Computer",
      component: AddComputer
    }
  ],
  enablePC: [
    {
      key: "enableMachine",
      title: "Enable Machine",
      component: BackupSettings
    }
  ],
  detailedProgress: [
    {
      key: "backupProgress",
      component: DetailedProgress
    }
  ],
  imageRestoreDetailedProgress: [
    {
      key: "imageRestoreProgress",
      component: DetailedProgress
    }
  ],
  settings: [
    {
      key: "backup",
      title: "Backup Settings",
      component: BackupSettings,
      icon: BackupIcon
    },
    {
      key: "logs",
      title: "Activity Logs",
      component: AppLogs,
      icon: LogsIcon,
      iconHover: LogsHoverIcon
    }
  ],
  virtualMachine: [
    {
      key: "addVirtualMachine",
      title: "Build Virtual Instance",
      component: AddVirtualMachine
    },
    {
      key: "editConfiguration",
      title: "Reconfigure Virtual Instance",
      component: VMConfiguration
    }
  ],
  backupPlan: [
    {
      key: "backupPlanSettings",
      title: "Update Backup Plan",
      component: BackupPlanSettings,
      cssClass: "updatePlanSlider active",
      noSideBarSlider: true
    },
    {
      key: "backupPlanPropagate",
      title: "Select Devices",
      component: BackupPlanPropagate,
      cssClass: "propagateSlider active",
      toolTip: TOOLTIPS.backupPlan.settings.addDevice,
      noSideBarSlider: true
    },
    {
      key: "createNewPlan",
      title: "Create Backup Plan",
      component: BackupPlanSettings,
      cssClass: "updatePlanSlider active",
      noSideBarSlider: true
    }
  ],
  dashboardHeader: [
    {
      key: "addToGroup",
      title: "Add to Group",
      component: AddToGroup,
      cssClass: "addGroupSlider_wrapper slider_active",
      noSideBarSlider: true
    }
  ],
  backupRestoreBothDetailedProgress: [
    {
      key: "backupProgress",
      title: "Backup Progress",
      component: BackupProgress,
      icon: SimultaneousBackupIcon
    },
    {
      key: "restoreProgress",
      title: "Restore Progress",
      component: RestoreDetailedProgress,
      icon: SimultaneousRestoreIcon
    }
  ],
  restoreOnlyDetailedProgress: [
    {
      key: "restoreProgress",
      title: "Restore Progress",
      component: RestoreDetailedProgress,
      icon: SimultaneousRestoreIcon
    }
  ]
};

// Slider Popups
export const SLIDER_POPUPS = {
  removeMachine: {
    title: "Delete Machine",
    body:
      "This will permanently delete the computer from your account. <br><br> On removing the computer, all its backed up data and recovery points for file restore and image restore will be deleted. Any ongoing backup or restore operation will also be stopped. This operation is irreversible. However, the backup agent will not be removed from the computer. <br></br> Are you sure you want to remove the computer <strong>'CLIENT_NAME'</strong>?",
    type: "Confirm",
    class: "popup_remove_machine",
    alertType: "WARN"
  },
  startFullBackup: {
    title: "Start Full Image Backup",
    body:
      "Full image backup will take more time to complete and consume more storage space. Are you sure you want to continue?",
    type: "Confirm",
    class: "popup_full_img_backup"
  },
  uncheckBootableVolume: {
    title: "Warning",
    body:
      "C: drive contains the operating system, boot information, settings, and application configurations required to perform a full system restore or to create a virtual instance of the computer. If you uncheck the C: drive, you cannot virtualize your computer or restore it to its earlier state on the same or new hardware.",
    type: "Confirm",
    class: "uncheckBootableVolume"
  },
  cleanup: {
    title: "Cleanup Now",
    body:
      "Cleanup operation will attempt to delete older backups depending on your backup retention settings. The web access will be unavailable until the cleanup operation is complete. Click 'Confirm' to start the cleanup operation.",
    type: "Confirm"
  },
  saveChanges: {
    title: "Save Changes",
    body: "Please Save the Changed Settings",
    type: "Save",
    class: "save_changes"
  },
  saveOrDiscardChanges: {
    title: "Save or Discard Changes",
    body:
      "If you leave without saving, the changes you made will be lost. Are you sure you want to leave?",
    type: "Save",
    secondType: "Discard",
    class: "save_discard"
  },
  saveOrDiscardSMTPChanges: {
    title: "Do you want to continue?",
    body: "SMTP settings will be set to default as no emails are added.",
    type: "Continue",
    secondType: "Cancel",
    class: "save_discard"
  },
  removeMachineWarningForVM: {
    title: "Delete Machine",
    body:
      "Unable to delete this machine because a virtual instance of it is currently active. To proceed, please delete the virtual instance from the <a href='/mirror/virtualization' style='color: black; font-weight: bold;'>Virtualization</a> first, and then delete this machine.",
    type: "Close",
    class: "popup_remove_machine",
    alertType: "save_changes",
    dontShowCancel: true
  },
  removeMachineVirtAPIError: {
    title: "Delete Machine",
    body:
      "Unable to verify whether a virtual instance for this machine exists because the server is currently unreachable. Please try again later.",
    type: "Close",
    class: "popup_remove_machine",
    alertType: "save_changes",
    dontShowCancel: true
  },
  cancelRestore: {
    title: "Cancel Restore",
    body:
      "Are you sure you want to cancel restore for <strong>'CLIENT_NAME'</strong>?",
    type: "Confirm"
  },
  cancelBackup: {
    title: "Cancel Backup",
    body:
      "Are you sure you want to cancel backup for <strong>'CLIENT_NAME'</strong>?",
    type: "Confirm"
  },
  pauseBackup: {
    title: "Pause Backup",
    body:
      "Are you sure you want to pause backup for <strong>'CLIENT_NAME'</strong>? <br/> On pausing the backup, the remaining files will not be backed up until resumed.",
    type: "Confirm"
  },
  disableScheduleBackup: {
    title: "Disable Schedule Backup",
    body:
      "Disabling the backup schedule will stop any upcoming backups on this device. <br/> Are you sure you want to proceed?",
    type: "Confirm"
  },
  schedulerDisableStartBckupImme: {
    title: "Modify Scheduled Job",
    body:
      "Scheduler settings cannot be modified while a backup operation is in progress.",
    type: "OK",
    dontShowCancel: true
  },
  schedulerDisableStartBckupImmeRestore: {
    title: "Modify Scheduled Job",
    body:
      "Backup cannot be performed as image restore for this machine is currently in progress.",
    type: "OK",
    dontShowCancel: true
  }
};

// Popups
export const POPUPS = {
  cancelbackup: {
    title: "Cancel Backup",
    body:
      "Are you sure you want to cancel backup for <strong>'CLIENT_NAME'</strong>?",
    type: "Confirm"
  },
  initRestore: {
    title: "Start Restore",
    body:
      "Click 'Confirm' to start restore for the machine <strong>'CLIENT_NAME'</strong>",
    note: "Restore progress will be shown on the respective machine selected.",
    type: "Confirm",
    class: "file_restore_popup"
  },
  originalLocationRestore: {
    title: "Restore to original location",
    body: originalFileRestorePopup,
    type: "Restore",
    class: "file_restore_popup",
    secondType: "Cancel"
  },
  cancelRestore: {
    title: "Cancel Restore",
    body:
      "Are you sure you want to Cancel <strong>'CLIENT_NAME'</strong> restore?",
    type: "Confirm"
  },
  pauseBackup: {
    title: "Pause Backup",
    body:
      "Are you sure you want to pause backup for <strong>'CLIENT_NAME'</strong>? <br/> On pausing the backup, the remaining files will not be backed up until resumed.",
    type: "Confirm",
    secondType: "Cancel"
  },
  addUsers: {
    title: "Add User",
    body: addUsersPopup,
    secondType: "Cancel",
    type: "Invite",
    popupWrapClass: "add_user active"
  },
  usersFailedList: {
    title: "Add User",
    body: usersFailedListPopup,
    secondType: "Cancel",
    type: "Invite",
    popupWrapClass: "add_user active loader_relative"
  },
  removeUserConfirmation: {
    title: "Delete User",
    body:
      "<p>This will permanently delete the user from your account along with all the associated computers and their backed-up data. The deleted user will not be able to sign in to their account.</p>Do you wish to proceed?",
    secondType: "Cancel",
    type: "Delete",
    popupWrapClass: "delete_user active loader_relative"
  },
  removeInviteConfirmation: {
    title: "Delete Invite",
    body: "Are you sure, you want to delete the invitation sent to the user?",
    secondType: "Cancel",
    type: "Delete",
    popupWrapClass: "delete_user active loader_relative"
  },
  cancelAccount: {
    title: "Are you sure you want to cancel your account?",
    body: CancelAccount,
    type: "Cancel My Account",
    popupWrapClass: "popup_account_delete"
  },
  CancelAccountConfirmation: {
    title: "Are you sure you want to cancel your account?",
    body: CancelAccountConfirmation,
    type: "Confirm",
    popupWrapClass: "popup_account_delete_confirm",
    alertType: "WARN"
  },
  changePassword: {
    title: "Change Password",
    body: ChangePassword,
    type: "Save",
    popupWrapClass: "popup_change_pwd"
  },
  passwordAuth: {
    title: "Change my email address",
    body: PasswordAuth,
    type: "Save Changes",
    popupWrapClass: "popup_change_email "
  },
  restoreCustomLocation: {
    title: "Specify Folder [CLIENT_NAME]",
    body: CustomLocationBody,
    type: "Done",
    popupWrapClass: "file_restore_sf_popup",
    leftFooter: "Create New Folder",
    secondType: "Cancel"
  },
  initImgRestore: {
    title: "The following volumes have been selected for restore",
    body: InitImgRestorePopupBody,
    type: "Ok",
    footer:
      "On restoring to the selected volumes of machine <strong>'CLIENT_NAME'</strong> any data on these volumes will be overwritten. Do you want to proceed?",
    popupWrapClass: "image_restore_popup",
    secondType: "Cancel"
  },
  downloadRestoreISO: {
    title: "Download Restore ISO Builder",
    body: DownloadRestoreISO,
    popupWrapClass: "popup_ISO_download file_restore_sf_popup "
  },
  upgradePlan: {
    title: "Payment Confirmation",
    body: UpgradePlanConfirmation,
    popupWrapClass: "popup_confirmation_upgrade"
  },
  systemRequirements: {
    title: "System Requirements",
    body: SystemRequirements,
    popupWrapClass: "sys_requirementPopup"
  },
  disableBackupPlan: {
    title: "Disable Backup Plans",
    body:
      "On disabling the selected plan(s), backup will be discontinued for all linked devices. Do you want to proceed?",
    type: "Disable",
    secondType: "Cancel"
  },
  enableBackupPlan: {
    title: "Enable Backup Plans",
    body:
      "Are you sure you want to enable the selected backup plan(s) for this account?",
    type: "Enable",
    secondType: "Cancel"
  },
  deleteBackupPlan: {
    title: "Delete Backup Plans",
    body: DeleteBackupPlanPopup,
    type: "Delete",
    secondType: "Cancel",
    popupWrapClass: "backupPlan_delete"
  },
  backupPlanConflict: {
    title: "Conflict Alert",
    body: BackupPlanConflictPopup,
    type: "Proceed",
    popupWrapClass: "conflictAlert_popup active"
  },
  ccUpdateLayout: {
    title: "Change credit card details",
    body: CCUpdateLayout,
    popupWrapClass: "updateCreditCard_popup active",
    type: "Save"
  },
  dashboardGroupsRename: {
    title: "Rename group",
    body: RenameGroup,
    type: "Save",
    popupWrapClass: "popup_rename_group active",
    secondType: "Cancel"
  },
  dashboardGroupsDelete: {
    title: "Delete Group",
    body: DeleteGroup,
    type: "Delete",
    popupWrapClass: "popup_delete_group active",
    secondType: "Cancel",
    alertType: "WARN"
  },
  createNewGroupDashboard: {
    title: "Create new group",
    body: CreateNewGroup,
    type: "Create",
    popupWrapClass: "popup_create_group active",
    secondType: "Cancel"
  },
  removeFromGroup: {
    title: "Remove from the group",
    body: RemoveFromGroup,
    type: "Remove",
    popupWrapClass: "popup_removefrom_group active",
    secondType: "Cancel",
    alertType: "WARN"
  },
  removeMachines: {
    title: "Delete Machine",
    body: RemoveMachines,
    type: "Delete",
    popupWrapClass: "popup_delete_group active",
    secondType: "Cancel",
    alertType: "WARN"
  },
  stopAllBackups: {
    title: "Stop All Backups",
    body:
      "The backup will stop for all the devices and will resume according to the next schedule. <br><br> Do you want to proceed?",
    type: "Yes",
    popupWrapClass: "popup_stop_allbkpups active",
    secondType: "Cancel"
  },
  applyPendingCharges: {
    title: "Your account has been suspended due to non-payment",
    body: ApplyPendingCharges,
    popupWrapClass: "account_suspend_popup active"
  },
  applyPendingChargesActivate: {
    title: "Change credit card details",
    body: CCUpdateLayout,
    popupWrapClass: "updateCreditCard_popup reactivate_acc_popup active"
  },
  DeleteVirtualInstance: {
    title: "Delete Virtual Instance",
    body: DeleteVirtualInstance,
    type: "Delete",
    secondType: "Cancel",
    popupWrapClass: "popup_account_delete_confirm",
    alertType: "WARN"
  },
  RebootVirtualInstance: {
    title: "Reboot Virtual Instance",
    body: RebootVirtualInstance,
    type: "Reboot",
    secondType: "Cancel",
    popupWrapClass: "popup_account_delete_confirm"
  },
  SwitchPowerVirtualInstance: {
    title: "Force Power Off Confirmation",
    body: SwitchPowerVirtualInstance,
    type: "Force Power Off",
    secondType: "Cancel",
    popupWrapClass: "popup_account_delete_confirm"
  },
  virtualizationConsoleSessionExists: {
    title: "Connection denied",
    body:
      "You are currently connected to this virtual instance from this browser. Disconnect the existing session to reconnect.",
    type: "Close",
    popupWrapClass: " popup_account_delete_confirm popup_connection_denied "
  }
};

// Dashboard Clients Filter options
export const CLIENTS_FILTER = {
  all: {
    class: "all",
    name: "All Computers"
  },
  new: {
    class: "new",
    name: "New Computers"
  },
  online: {
    class: "online",
    name: "Online"
  },
  offline: {
    class: "offline",
    name: "Offline"
  },
  inprogress: {
    class: "inprogress",
    name: "Backup in progress"
  },
  inprogress_restore: {
    class: "inprogress_restore",
    name: "Restore in progress"
  },
  virtualization_on: {
    class: "virtualization_on",
    name: "Virtual Instances"
  }
};

export const RESTORE_CLIENT_FILTER = {
  all: {
    class: "all",
    name: "All Computers"
  },

  online: {
    class: "online",
    name: "Online"
  },
  offline: {
    class: "offline",
    name: "Offline"
  },
  inprogress: {
    class: "inprogress",
    name: "Restore in progress"
  }
};

//  Classess for all the transitions in the App
export const TRANSITION_CLASSESS = {
  slidingPopup: {
    main: {
      component: { base: "slider_wrapper", active: "slider_active" },
      shadow: { base: "slider_bg_shadow", active: "slider_active" }
    },
    popup: {
      component: { base: "popup_wrap", active: "active" },
      shadow: { base: "slider_popup", active: "active" }
    },
    mainAddComputer: {
      component: {
        base: "slider_wrapper",
        active: "slider_active welcome_slider"
      },
      shadow: { base: "slider_bg_shadow", active: "slider_active" }
    }
  }
};

// Navigation for app
export const AUTH_LIST = [
  {
    name: "Login",
    path: "/mirror/login",
    component: Login
  },
  // {
  //   name: "Switch 90",
  //   path: "/mirror/signup/:promo",
  //   component: RegisterPromo
  // },
  // {
  //   name: "Signup",
  //   path: "/mirror/signup",
  //   component: Register
  // },

  {
    name: "Forgot Password",
    path: "/mirror/forgotPassword",
    component: RedirectPassword
  },
  {
    name: "Reset Password",
    path: "/mirror/updatePassword",
    component: UpdatePassword
  },
  {
    name: "Version Add and Update",
    path: "/admin/versionAddAndUpdate",
    component: VersionAddAndUpdate
  },
  {
    name: "PNS Admin Control",
    path: "/admin/pns",
    component: Pns
  },
  {
    name: "Sub User",
    path: "/mirror/activateSubUser",
    component: SubUser
  },
  {
    name: "Idrive 360",
    path: "/mirror/validate360",
    component: Idrive360
  },
  {
    name: "Logout 360",
    path: "/mirror/logout360",
    component: Logout360
  },
  {
    name: "Ibackup",
    path: "/mirror/validateIbackup",
    component: Ibackup
  }
  // {
  //   name: "LogoutIbackup",
  //   path: "/mirror/logoutIbackup",
  //   component: LogoutIbackup
  // }
];

export const NAV_LIST = [
  {
    key: "dashboard",
    name: "Dashboard",
    iconClass: "dashboard_li",
    path: "/mirror/dashboard",
    component: Dashboard
  },
  {
    key: "backupPlan",
    name: "Backup Plan",
    iconClass: "bkpPlan_li",
    path: "/mirror/backupPlan",
    component: BackupPlan
  },
  {
    key: "restore",
    name: "Restore",
    iconClass: "restore_li",
    path: "/mirror/restore",
    component: Restore
  },
  {
    key: "virtualization",
    name: "Virtualization",
    iconClass: "virtual_li virtual_ib_li ",
    path: "/mirror/virtualization",
    newTag: true,
    component: Virtualization
  },
  {
    key: "webActivityLogs",
    name: "Web Activity Logs",
    iconClass: "webacitivity_li",
    path: "/mirror/activities",
    component: Activities
  },
  {
    key: "user_management",
    name: "Users",
    iconClass: "users_li",
    path: "/mirror/users",
    component: Users
  },
  {
    key: "account",
    name: "Account",
    iconClass: "account_li",
    path: "/mirror/account",
    component: Account
  }
];

export const NAV_LIST_SUB = [
  {
    key: "dashboard",
    name: "Dashboard",
    iconClass: "dashboard_li",
    path: "/mirror/dashboard",
    component: Dashboard
  },
  {
    key: "backupPlan",
    name: "Backup Plan",
    iconClass: "bkpPlan_li",
    path: "/mirror/backupPlan",
    component: BackupPlan
  },
  {
    key: "restore",
    name: "Restore",
    iconClass: "restore_li",
    path: "/mirror/restore",
    component: Restore
  },
  {
    key: "virtualization",
    name: "Virtualization",
    iconClass: "virtual_li virtual_ib_li ",
    path: "/mirror/virtualization",
    newTag: true,
    component: Virtualization
  },
  {
    key: "webActivityLogs",
    name: "Web Activity Logs",
    iconClass: "webacitivity_li",
    path: "/mirror/activities",
    component: Activities
  },
  {
    key: "account",
    name: "Account",
    iconClass: "account_li",
    path: "/mirror/account",
    component: Account
  }
];

export const NAV_LIST_360 = [
  {
    key: "dashboard",
    name: "Dashboard",
    iconClass: "dashboard_li",
    path: "/mirror/dashboard",
    component: Dashboard
  },
  {
    key: "backupPlan",
    name: "Backup Plan",
    iconClass: "bkpPlan_li",
    path: "/mirror/backupPlan",
    component: BackupPlan
  },
  {
    key: "restore",
    name: "Restore",
    iconClass: "restore_li",
    path: "/mirror/restore",
    component: Restore
  },
  {
    key: "virtualization",
    name: "Virtualization",
    iconClass: "virtual_li virtual_ib_li ",
    path: "/mirror/virtualization",
    newTag: true,
    component: Virtualization
  },
  {
    key: "webActivityLogs",
    name: "Web Activity Logs",
    iconClass: "webacitivity_li",
    path: "/mirror/activities",
    component: Activities
  }
];

export const INDEPENDENT_LIST = [
  {
    key: "invoice",
    name: "Invoice",
    path: "/mirror/account/billingInformation/invoice",
    component: Invoice
  },
  {
    key: "previewBilling",
    name: "Preview Billing",
    path: "/mirror/account/billingInformation/previewBilling",
    component: PreviewBilling
  },
  //not used in app flow
  {
    key: "client-setup",
    name: "Client Setup",
    path: "/mirror/downloads/clientSetup",
    component: ClientSetup
  },
  {
    key: "client-setup",
    name: "Client Setup",
    path: "/mirror/viconsole",
    component: VMConsole
  }
];

export const EXCEPTION_LIST = [
  // {
  //   name: "Switch 90",
  //   path: "/mirror/signup/:promo",
  //   component: RegisterPromo
  // },
  // {
  //   name: "Signup",
  //   path: "/mirror/signup",
  //   component: Register
  // },

  {
    name: "Reset Password",
    path: "/mirror/updatePassword",
    component: UpdatePassword
  },
  {
    name: "Sub User",
    path: "/mirror/activateSubUser",
    component: SubUser
  },
  {
    name: "Version Add and Update",
    path: "/admin/versionAddAndUpdate",
    component: VersionAddAndUpdate
  },
  {
    name: "Pns",
    path: "/admin/pns",
    component: Pns
  },
  {
    name: "Idrive 360",
    path: "/mirror/validate360",
    component: Idrive360
  },
  {
    name: "Logout 360",
    path: "/mirror/logout360",
    component: Logout360
  },
  {
    name: "Ibackup",
    path: "/mirror/validateIbackup",
    component: Ibackup
  },
  {
    name: "LogoutIbackup",
    path: "/mirror/logoutIbackup",
    component: LogoutIbackup
  },
  {
    name: "Forgot Password",
    path: "/mirror/forgotPassword",
    component: RedirectPassword
  }
];

export const NOTIFICATION_STATUS = {
  success: {
    name: "success",
    class: "success_notify",
    wrapClass: "safe",
    svg: SuccessAlertIcon
  },
  failure: {
    name: "failure",
    class: "error_notify",
    wrapClass: "error",
    svg: OfflineAlertIcon
  },
  warning: {
    name: "warning",
    class: "success_notify",
    wrapClass: "alert",
    svg: OfflineAlertIcon
  }
};

export const USERS_HEADER_TABLE = [
  {
    key: "email",
    title: "Email Address"
  },
  {
    key: "name",
    title: "Name"
  },
  {
    key: "quota",
    title: "Quota"
  },
  {
    key: "computer",
    title: "Computer"
  },
  {
    key: "status",
    title: "Status"
  }
];

export const ROUTECLASS_LIST = {
  welcome: "welcome_page",
  dashboard: "main_dashboard dashboard_views virtaul_view",
  virtualization: "virtualization_module",
  activities: "main_weblogs",
  account: "main_account_info myaccount_wrap im-25-offer",
  login: "mirror_login_signup",
  restore: "main_dashboard restore_page",
  users: "user_management",
  file: "restore_page",
  image: "restore_page",
  backupPlan: "main_dashboard bkpPlan_page"
};

//Account Header Tabs
export const ACCOUNT_SETTINGS_TABS = {
  profileDetails: {
    key: "profileDetails",
    name: "Profile Details",
    dataValue: "profile__details",
    path: "/mirror/account/profileDetails",
    class: "li_profile",
    icon: UserIcon,
    component: ProfileDetails
  },
  planOptions: {
    key: "planOptions",
    name: "Plan Options",
    dataValue: "plan__options",
    path: "/mirror/account/planOptions",
    class: "li_plan",
    icon: PlanOptionsIcon,
    component: PlanOptions
  },
  updateCreditCard: {
    key: "updateCreditCard",
    name: "Update Credit Card",
    dataValue: "update__credit__card",
    path: "/mirror/account/updateCreditCard",
    class: "li_cc",
    icon: UserRefreshIcon,
    component: UpdateCreditCard
  },
  billingInformation: {
    key: "billingInformation",
    name: "Billing Information",
    dataValue: "billing__information",
    path: "/mirror/account/billingInformation",
    class: "li_billing",
    icon: DollorIcon,
    component: BillingInformation
  }
};

//Account Header tabs for free account
export const ACCOUNT_SETTINGS_TABS_FREE = {
  profileDetails: {
    key: "profileDetails",
    name: "Profile Details",
    dataValue: "profile__details",
    path: "/mirror/account/profileDetails",
    class: "li_profile",
    icon: UserIcon,
    component: ProfileDetails
  },
  planOptions: {
    key: "planOptions",
    name: "Plan Options",
    dataValue: "plan__options",
    path: "/mirror/account/planOptions",
    class: "li_plan",
    icon: PlanOptionsIcon,
    component: PlanOptions
  }
};

export const ACCOUNT_SETTINGS_TABS_SUB = {
  profileDetails: {
    key: "profileDetails",
    name: "Profile Details",
    dataValue: "profile__details",
    path: "/mirror/account/profileDetails",
    class: "li_profile",
    icon: UserIcon,
    component: ProfileDetails
  }
};

// Icons for machine status in dashboard
export const MACHINE_STATUS_ICONS = {
  backup_row_online_safe: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  backup_row_online_backup: {
    name: "safe backup",
    component: SafeOnlineIcon
  },
  backup_row_online_safe_backup: {
    name: "safe backup",
    component: SafeOnlineIcon
  },
  backup_row_online_safe_restore: {
    name: "safe restore",
    component: SafeOnlineIcon
  },
  backup_row_online_restore: {
    name: "safe restore",
    component: SafeOnlineIcon
  },
  backup_row_online: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  backup_row_online_backup: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  backup_row_offline_safe: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_offline_safe_icon_stripe: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_offline: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_offline_new_pc: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_offline_new_pc_restore: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_offline_new_pc_backup: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_backup_row_p50_offline_new_pc_backup: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  backup_row_online_new_pc: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  backup_row_online_new_pc_restore: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  backup_row_online_new_pc_backup: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  backup_row_backup_row_p50_online_new_pc_backup: {
    name: "safe online",
    component: SafeOnlineIcon
  }
};

// New object icons for machine statuses on the dashboard
export const MACHINE_ICONS = {
  online: {
    name: "safe online",
    component: SafeOnlineIcon
  },
  offline: {
    name: "safe offline",
    component: SafeOfflineIcon
  },
  online_error: {
    name: "error online",
    component: ErrorOnlineIcon
  },
  offline_error: {
    name: "error offline",
    component: ErrorOfflineIcon
  }
};

export const RESTORE_LOCATION_TYPES = {
  CUSTOM: {
    key: "custom",
    class: "custome_location_wrap",
    content: "Restore Location",
    title: "Your files will be restored to the custom location of your choice."
  },
  ORIGINAL: {
    key: "original",
    class: "rlo_wrap",
    content: "Restore to original location",
    title:
      "Your files will be restored to the same location from where they were backed up to the cloud"
  }
};

export const ADD_COMPUTER_STEPS = {
  steps: [
    {
      title: "Add Computer",
      content: {
        mirror:
          "Download and install IDrive<sup>®</sup> Mirror application on your computer to backup your entire system and associated VMs.",
        ibackup:
          "Download and install IBackup<sup>®</sup> Mirror application on your computer to backup your entire system and associated VMs.",
        mirror360:
          "Download and install IDrive<sup>®</sup> Mirror thin client application on your computer to backup your entire system and associated VMs."
      },
      icon: AddComputerIcon,
      newIcon: AddComputerNewIcon
    },
    {
      title: "Easy Configuration",
      content:
        "Once installed, you can instantly enable data backup and remotely manage the backup operations.",
      icon: EasyConfigIcon
    },
    {
      title: "Start Backup",
      content:
        "Click 'Enable Now' to initiate a full image backup of the configured computer.",
      icon: StartBackupIcon
    }
  ]
};

export const ALL_PLAN_TYPES = {
  free: {
    id: "free",
    title: "Free",
    series: 1,
    class: "freePlan"
  },
  personal: {
    id: "personal",
    title: "Personal",
    series: 100,
    class: "personalPlan"
  },
  team: {
    id: "team",
    title: "Team",
    series: 200,
    class: "teamPlan"
  }
};

export const BACKUP_PLAN_SETTINGS = {
  summary: {
    key: "summary",
    title: "Update Backup Plan",
    component: BackupPlanSummary,
    cssClass: "updatePlanSlider active"
  },
  edit: {
    key: "edit",
    name: "Update Backup Plan",
    component: EditPlanSettings,
    cssClass: "updatePlanSlider active"
  }
};

export const EDIT_BACKUP_PLAN_SETTINGS = {
  addDevices: {
    key: "addDevices",
    title: "Select Devices",
    class: "devices_blk",
    component: AddDevices,
    toolTip: TOOLTIPS.backupPlan.settings.addDevice
  },
  schedule: {
    key: "schedule",
    title: "Schedule Backup",
    class: "schedule_blk",
    component: BackupPlanSchedule
  },
  email: {
    key: "email",
    title: "Email Notification",
    class: "emailNotify_blk summary_wrap summary_email is_relative",
    component: BackupPlanEmailNotification
  },
  advanceSettings: {
    key: "advanceSettings",
    title: "Advanced Settings",
    class: "advSettings_blk summary_wrap summary_advance_settings is_relative",
    component: BackupPlanAdvanceSettings
  }
};

// Schedule types
export const BACKUP_PLAN_SCHEDULE_TYPES = {
  MONTHLY: {
    key: "MONTHLY",
    name: "Monthly",
    component: BackupPlanMonthly
  },
  CUSTOM: {
    key: "CUSTOM",
    name: "Weekly",
    component: BackupPlanScheduleCustom
  },
  DAILY: {
    key: "DAILY",
    name: "Daily",
    component: BackupPlanDaily
  },
  INTERVAL: {
    key: "INTERVAL",
    name: "Interval",
    component: BackupPlanInterval
  }
};

export const DASHBOARD_VIEW_TYPES = {
  list: {
    key: "list",
    name: "List",
    wrapperClass: "tbl_listView_wrapper",
    icon_active: ListViewIconActive,
    icon_inactive: ListViewIconInActive
  },
  grid: {
    key: "grid",
    name: "Grid",
    wrapperClass: "tbl_gridView_wrapper",
    icon_active: GridViewIconActive,
    icon_inactive: GridViewIconInActive
  }
};

export const DASHBOARD_VIEW_HEADER = {
  name: {
    key: "name",
    name: "Name",
    value: "name",
    class: "dev_name"
  },
  bkp_status: {
    key: "bkp_status",
    name: "Status",
    value: "status",
    class: "bkp_status"
  },
  lastBackup: {
    key: "lastBackup",
    name: "Last Backup",
    value: "lastBackupTime",
    class: "last_backup"
  },
  nextBackup: {
    key: "nextBackup",
    name: "Next Backup",
    value: "nextBackupTime",
    class: "next_backup"
  },
  spaceUsed: {
    key: "spaceUsed",
    name: "Space Used",
    value: "cloudUsage",
    class: "space_used"
  },
  group: {
    key: "group",
    name: "Group Name",
    value: "groupName",
    class: "group"
  },
  buttons: {
    key: "buttons",
    name: null,
    class: "btn"
  }
};
